(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["script-accordion"] && !Shopify.designMode) return;
  try {
    /*
 * Accordion — max-height toggle with an optional one-open-at-a-time mode.
 * The panel settles to `none` after opening so later reflows aren't clipped.
 * Hooks: [data-accordion], [data-accordion-item], [data-accordion-trigger],
 *        [data-accordion-panel]
 */

(function () {
  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function close(item) {
    const panel = item.querySelector('[data-accordion-panel]');
    const trigger = item.querySelector('[data-accordion-trigger]');
    if (!panel || !trigger) return;

    panel.style.maxHeight = panel.scrollHeight + 'px';
    void panel.offsetHeight;
    item.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    panel.style.maxHeight = '';
  }

  function open(item) {
    const panel = item.querySelector('[data-accordion-panel]');
    const trigger = item.querySelector('[data-accordion-trigger]');
    if (!panel || !trigger) return;

    item.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    panel.style.maxHeight = panel.scrollHeight + 'px';
    if (REDUCED.matches) panel.style.maxHeight = 'none';
  }

  function initAccordion(root) {
    if (root.dataset.accordionInit === 'true') return;
    root.dataset.accordionInit = 'true';

    const single = root.dataset.accordionSingle === 'true';
    const items = Array.from(root.querySelectorAll('[data-accordion-item]'));

    items.forEach(function (item) {
      const trigger = item.querySelector('[data-accordion-trigger]');
      const panel = item.querySelector('[data-accordion-panel]');
      if (!trigger || !panel) return;

      panel.addEventListener('transitionend', function (e) {
        if (e.propertyName === 'max-height' && item.classList.contains('is-open')) {
          panel.style.maxHeight = 'none';
        }
      });

      trigger.addEventListener('click', function () {
        const isOpen = item.classList.contains('is-open');

        if (single) {
          items.forEach(function (other) {
            if (other !== item && other.classList.contains('is-open')) close(other);
          });
        }

        if (isOpen) {
          close(item);
        } else {
          open(item);
        }
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-accordion]').forEach(initAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-accordion]').forEach(function (root) {
      root.dataset.accordionInit = 'false';
      initAccordion(root);
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["script-collection-banner"] && !Shopify.designMode) return;
  try {
    /*
 * Collection banner — draggable category swiper.
 * Mobile 2-up, desktop free-width 280px slides that bleed past the margin.
 * Hooks: [data-collection-banner], [data-category-slider]
 */

(function () {
  function initBanner(root) {
    if (root.dataset.bannerInit === 'true') return;
    root.dataset.bannerInit = 'true';

    const el = root.querySelector('[data-category-slider]');
    if (!el || !window.Swiper) return;

    new window.Swiper(el, {
      slidesPerView: 2,
      spaceBetween: 4,
      speed: 400,
      grabCursor: true,
      /* Centre the row when the slides don't fill the track. Swiper's own
         option, not CSS: centring .swiper-wrapper with flex moves the slides
         out from under the transform Swiper positions them with, so its snap
         points and drag bounds stop matching what's on screen. This shifts the
         translate instead, which keeps that maths intact. No effect once there
         are enough slides to overflow. */
      centerInsufficientSlides: true,
      // Slides bleed to the section edge; the section clips them.
      watchOverflow: true,
      mousewheel: {
        // Horizontal slider: without forceToAxis a normal vertical page scroll
        // would drag the slides sideways. releaseOnEdges hands scrolling back to
        // the page at the first/last slide instead of trapping it.
        forceToAxis: true,
        releaseOnEdges: true,
      },
      breakpoints: {
        769: { slidesPerView: 'auto', spaceBetween: 24 },
      },
    });
  }

  function init() {
    document.querySelectorAll('[data-collection-banner]').forEach(initBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('[data-collection-banner]');
    if (root) { root.dataset.bannerInit = 'false'; initBanner(root); }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["script-contact"] && !Shopify.designMode) return;
  try {
    /*
 * Contact — TomSelect on the enquiry reason dropdown.
 * Validation itself is global (global-scripts.js, opted in with [data-validate]);
 * this only keeps the styled control in step with the error state, since
 * TomSelect hides the real <select> that global validation focuses.
 * TomSelect is loaded globally in theme.liquid.
 * Hooks: [data-contact-reason]
 */

(function () {
  function initReason(select) {
    if (select.dataset.reasonInit === 'true') return;
    if (typeof TomSelect === 'undefined') return;
    select.dataset.reasonInit = 'true';

    const control = new TomSelect(select, {
      controlInput: null,
      create: false,
      allowEmptyOption: true,
      hideSelected: false,
    });

    // The native select is hidden, so send focus to the visible control when
    // validation lands on this field.
    select.addEventListener('focus', function () {
      control.focus();
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-contact-reason]').forEach(initReason);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["script-error-banner"] && !Shopify.designMode) return;
  try {
    /*
 * Error banner — raises the card object into the heading on load.
 * Hook: [data-error-object]
 */

(function () {
  function raise(obj) {
    if (obj.dataset.errorInit === 'true') return;
    obj.dataset.errorInit = 'true';

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      obj.classList.add('is-in');
      return;
    }

    requestAnimationFrame(() => {
      setTimeout(() => obj.classList.add('is-in'), 350);
    });
  }

  function init(root = document) {
    root.querySelectorAll('[data-error-object]').forEach(raise);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["script-featured-collection-carousel"] && !Shopify.designMode) return;
  try {
    /*
 * Featured collection carousel — Swiper with fixed-width slides that bleed
 * off the right edge.
 * Hooks: [data-featured-collection-carousel], [data-fcc-slider],
 *        [data-fcc-prev], [data-fcc-next]
 */

(function () {
  function initCarousel(root) {
    if (root.dataset.fccInit === 'true') return;
    root.dataset.fccInit = 'true';

    const el = root.querySelector('[data-fcc-slider]');
    if (!el || !window.Swiper) return;

    new window.Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 24,
      speed: 400,
      navigation: {
        prevEl: root.querySelector('[data-fcc-prev]'),
        nextEl: root.querySelector('[data-fcc-next]'),
        disabledClass: 'is-disabled',
      },
      mousewheel: {
        forceToAxis: true,
        releaseOnEdges: true,
      },
    });
  }

  function init() {
    document.querySelectorAll('[data-featured-collection-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('[data-featured-collection-carousel]');
    if (root) {
      root.dataset.fccInit = 'false';
      initCarousel(root);
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["script-featured-product-tabs"] && !Shopify.designMode) return;
  try {
    /*
 * Featured product tabs — switches the media and the purchase panel together.
 * All panels are rendered server-side and toggled, so switching is instant
 * (no fetch). The section background is static and not touched here.
 *
 * Hooks: [data-featured-tabs], [data-tab], [data-panel], [data-media-panel]
 */

(function () {
  function initTabs(root) {
    if (root.dataset.tabsInit === 'true') return;
    root.dataset.tabsInit = 'true';

    const tabs = Array.from(root.querySelectorAll('[data-tab]'));
    if (!tabs.length) return;

    function activate(id) {
      tabs.forEach((tab) => {
        const on = tab.dataset.tab === id;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      root.querySelectorAll('[data-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.panel !== id;
      });

      root.querySelectorAll('[data-media-panel]').forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.mediaPanel === id);
      });
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => activate(tab.dataset.tab));
    });

    // Left/right arrows move between tabs, per the tablist pattern.
    tabs.forEach((tab, i) => {
      tab.addEventListener('keydown', (e) => {
        let next = null;
        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        if (!next) return;
        e.preventDefault();
        next.focus();
        activate(next.dataset.tab);
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-featured-tabs]').forEach(initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('[data-featured-tabs]');
    if (root) { root.dataset.tabsInit = 'false'; initTabs(root); }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["script-featured-products"] && !Shopify.designMode) return;
  try {
    /*
 * Featured Products — a single drag/scroll product slider (no tabs, no arrows,
 * per the design). Cards are auto-width so slidesPerView stays 'auto'.
 * Swiper is loaded globally in theme.liquid.
 * Hooks: [data-featured-products], [data-fp-swiper]
 */

(function () {
  function initSlider(el) {
    if (el.dataset.fpInit === 'true' || !window.Swiper) return;
    el.dataset.fpInit = 'true';

    new window.Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 24,
      speed: 400,
      grabCursor: true,
      observer: true,
      observeParents: true,
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-fp-swiper]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["script-fixtures-results"] && !Shopify.designMode) return;
  try {
    /*
 * Fixtures & Results — Fixtures/Results tab switching, plus the Explore More
 * slider. Both tab panels render server-side, so switching is a visibility
 * toggle with no fetch. The slider only exists below 992px; above that the
 * track is a plain flex row, so the Swiper is destroyed.
 *
 * Hooks: [data-fixtures-results], [data-fr-tab], [data-fr-panel],
 *        [data-fr-explore], [data-fr-explore-current]
 */

(function () {
  const DESKTOP = window.matchMedia('(min-width: 992px)');

  function initExplore(row) {
    if (!window.Swiper) return;

    if (DESKTOP.matches) {
      if (row.swiper) row.swiper.destroy(true, true);
      return;
    }
    if (row.swiper) return;

    const slides = Array.from(row.querySelectorAll('.swiper-slide'));
    const current = row.querySelector('[data-fr-explore-current]');
    const start = current ? slides.indexOf(current) : 0;

    /* Deliberately NOT centeredSlides: centeredSlidesBounds is unreliable with
       slidesPerView:'auto' + spaceBetween, which left dead space draggable at
       both ends and mispositioned the starting slide. Left-aligned snapping
       clamps to 0..maxTranslate, so the ends are hard stops. */
    const swiper = new window.Swiper(row, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      /* Without a threshold Swiper reads the few px of movement in a tap as a
         drag and snaps on release, animating the row a frame before the link
         navigates. */
      threshold: 10,
      grabCursor: true,
      observer: true,
      observeParents: true,
      mousewheel: { forceToAxis: true, releaseOnEdges: true },
    });

    /* slideTo after construction rather than initialSlide — it runs once Swiper
       has measured, so it can't be thrown off by layout that settled late.
       Swiper clamps it, so the last card lands flush right instead of dragging
       empty space into view. Re-assert on load in case a late shift moved the
       snap points, unless the visitor has already taken hold of the slider. */
    let touched = false;
    swiper.on('touchStart', () => { touched = true; });

    function landOnCurrent() {
      if (!touched && start > 0) swiper.slideTo(start, 0, false);
    }

    landOnCurrent();
    if (document.readyState !== 'complete') {
      window.addEventListener('load', landOnCurrent, { once: true });
    }
  }

  function initRoot(root) {
    if (root.dataset.frInit === 'true') return;
    root.dataset.frInit = 'true';

    const tabs = Array.from(root.querySelectorAll('[data-fr-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-fr-panel]'));
    if (!tabs.length || !panels.length) return;

    function activate(name, animate) {
      tabs.forEach((tab) => {
        const on = tab.dataset.frTab === name;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      panels.forEach((panel) => {
        const on = panel.dataset.frPanel === name;
        panel.hidden = !on;
        if (on && animate) {
          panel.classList.remove('is-entering');
          void panel.offsetWidth;
          panel.classList.add('is-entering');
        }
      });
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => activate(tab.dataset.frTab, true));
    });
  }

  function init() {
    document.querySelectorAll('[data-fixtures-results]').forEach(initRoot);
    document.querySelectorAll('[data-fr-explore]').forEach(initExplore);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  DESKTOP.addEventListener('change', init);
  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["script-footer-logo-roll"] && !Shopify.designMode) return;
  try {
    /* Footer wordmark roll.
   Hinges the wordmark up from flat on scroll. In 'letters' mode the inline SVG
   is split into one element per letter (measured via getBBox, nothing
   hardcoded) and each hinges in turn; in 'whole' mode the mark tips as a single
   plane. Self-contained — all styling is inline.
   Remove this file and its <script> tag in sections/footer.liquid to revert. */
(function () {
  var P = {
    // 'letters' = each letter hinges independently, with a stagger.
    // 'whole'   = the entire wordmark tips as one rigid plane.
    mode: 'letters',
    duration: 0.9,
    ease: 'power3.out',
    // Time offset between letters. Higher = less mid-roll overlap between
    // neighbours. Unused in 'whole' mode.
    stagger: 0.14,
    // Distance to the vanishing point. Lower = stronger foreshortening, but
    // also more magnification as a letter tips toward the camera, which is what
    // makes neighbours collide mid-roll.
    perspective: 1130,
    // Start angle. -90 = lying flat toward the camera, rolling back into place.
    startRotation: -90,
    // Hinge axis angle. 0 = horizontal axis along the letter's bottom edge.
    // A rotation only leaves points ON its axis fixed, so 0 is the only value
    // that keeps the whole baseline planted.
    tilt: 0,
    // Hinge point as a % of each letter's box. 50/100 = bottom-centre, putting
    // the axis exactly on the bottom edge. originY must stay 100 for the
    // baseline to hold.
    originX: 50,
    originY: 100,
    // Playback rate. 1 = real speed.
    slowMo: 1
  };

  // Returns false only when the wordmark exists but isn't measurable yet, which
  // tells the bootstrap below to try again on the next frame. Every other exit
  // is final.
  function init() {
    gsap.registerPlugin(ScrollTrigger);

    var wrap = document.querySelector('.footer-logo');
    if (!wrap || wrap.dataset.rollInit) return true;

    var svg = wrap.querySelector('svg');
    if (!svg) return true;

    var vb = svg.viewBox.baseVal;
    var defs = svg.querySelector('defs');

    // The glyphs are painted with a <pattern> whose only content is the noise
    // bitmap. Until that image decodes the pattern paints NOTHING — the letters
    // are invisible, not merely untextured — so the roll has to wait for it.
    var noise = svg.querySelector('image');
    var noiseSrc = noise && (noise.getAttribute('href') || noise.getAttribute('xlink:href'));

    var paths = Array.prototype.slice.call(svg.querySelectorAll('path'));
    if (!paths.length) return true;

    // Measure every path, then sort left-to-right for grouping/stagger order.
    // docIndex preserves the original SVG document order, which is NOT
    // left-to-right and which determines how the overlapping glyphs stack.
    var items = paths.map(function (p, idx) {
      var b = p.getBBox();
      return { path: p, docIndex: idx, x: b.x, y: b.y, w: b.width, h: b.height };
    }).sort(function (a, b) { return a.x - b.x; });

    if (!items[0].w) return false; // not laid out yet — retry next frame

    // Group into letters. Small marks (the ®) merge into the letter before them
    // instead of becoming their own animated unit.
    var groups = [];
    items.forEach(function (it) {
      var isMark = it.w < vb.width * 0.04;
      if (isMark && groups.length) {
        groups[groups.length - 1].push(it);
      } else {
        groups.push([it]);
      }
    });

    // Container mirrors the SVG's aspect ratio so % positioning stays exact.
    wrap.style.position = 'relative';
    wrap.style.aspectRatio = vb.width + ' / ' + vb.height;
    wrap.setAttribute('role', 'img');
    if (svg.getAttribute('aria-label')) {
      wrap.setAttribute('aria-label', svg.getAttribute('aria-label'));
    }

    // Tilting the hinge axis requires conjugating the rotation:
    //   rotateZ(tilt) . rotateX(angle) . rotateZ(-tilt)
    // which is a rotation of `angle` about an axis lying at `tilt` degrees in
    // the plane. GSAP only exposes one Z rotation per element, so this is three
    // nested boxes sharing one transform-origin; the pair of Z rotations
    // cancels to identity when angle is 0.
    var LAYER = 'display:block;width:100%;height:100%;transform-style:preserve-3d;';
    var ORIGIN = P.originX + '% ' + P.originY + '%';

    function makeHinge() {
      var tilt = document.createElement('span');
      var hinge = document.createElement('span');
      var counter = document.createElement('span');
      tilt.style.cssText = LAYER + 'transform-origin:' + ORIGIN + ';transform:rotateZ(' + P.tilt + 'deg);';
      hinge.style.cssText = LAYER + 'transform-origin:' + ORIGIN + ';will-change:transform;';
      counter.style.cssText = LAYER + 'transform-origin:' + ORIGIN + ';transform:rotateZ(' + -P.tilt + 'deg);';
      tilt.appendChild(hinge);
      hinge.appendChild(counter);
      return { tilt: tilt, hinge: hinge, counter: counter };
    }

    // In 'whole' mode this loop is skipped — it moves the paths out of the
    // source SVG, which whole mode needs intact.
    var units = P.mode === 'whole' ? [] : groups.map(function (group, i) {
      // Union bbox for the group.
      var x0 = Math.min.apply(null, group.map(function (g) { return g.x; }));
      var y0 = Math.min.apply(null, group.map(function (g) { return g.y; }));
      var x1 = Math.max.apply(null, group.map(function (g) { return g.x + g.w; }));
      var y1 = Math.max.apply(null, group.map(function (g) { return g.y + g.h; }));
      var w = x1 - x0;
      var h = y1 - y0;

      var span = document.createElement('span');
      span.style.cssText =
        'position:absolute;display:block;' +
        'left:' + (x0 / vb.width * 100) + '%;' +
        'top:' + (y0 / vb.height * 100) + '%;' +
        'width:' + (w / vb.width * 100) + '%;' +
        'height:' + (h / vb.height * 100) + '%;' +
        'transform-style:preserve-3d;';

      var layers = makeHinge();

      var letterSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      letterSvg.setAttribute('viewBox', x0 + ' ' + y0 + ' ' + w + ' ' + h);
      letterSvg.setAttribute('fill', 'none');
      letterSvg.setAttribute('aria-hidden', 'true');
      letterSvg.style.cssText = 'display:block;width:100%;height:100%;overflow:visible;';

      // Each clone needs its own <defs> with a unique pattern id. The pattern is
      // userSpaceOnUse in the original coordinate space, so the noise stays
      // continuous across letters even though each viewBox is cropped.
      if (defs) {
        var defsClone = defs.cloneNode(true);
        Array.prototype.forEach.call(defsClone.querySelectorAll('[id]'), function (node) {
          var oldId = node.id;
          var newId = oldId + '-' + i;
          node.id = newId;
          group.forEach(function (g) {
            ['fill', 'stroke'].forEach(function (attr) {
              var v = g.path.getAttribute(attr);
              if (v && v.indexOf('#' + oldId + ')') !== -1) {
                g.path.setAttribute(attr, v.replace('#' + oldId + ')', '#' + newId + ')'));
              }
            });
          });
        });
        letterSvg.appendChild(defsClone);
      }

      group.forEach(function (g) { letterSvg.appendChild(g.path); });
      layers.counter.appendChild(letterSvg);
      span.appendChild(layers.tilt);
      // NOTE: not appended to wrap here — see the doc-order pass below.
      return {
        span: span,
        hinge: layers.hinge,
        face: letterSvg,
        doc: Math.min.apply(null, group.map(function (g) { return g.docIndex; }))
      };
    });

    if (P.mode === 'whole') {
      // One hinge, the untouched SVG inside it. Glyph overlap is impossible by
      // construction and the original paint order is preserved for free.
      var layers = makeHinge();
      svg.style.cssText = 'display:block;width:100%;height:100%;';
      layers.counter.appendChild(svg);
      wrap.appendChild(layers.tilt);
      units = [{ span: layers.tilt, hinge: layers.hinge, face: svg, doc: 0 }];
    } else {
      // Paint in the original SVG document order so the overlapping glyphs stack
      // exactly as designed. `units` stays in left-to-right order, so the
      // stagger still cascades across the word regardless of DOM order.
      units.slice()
        .sort(function (a, b) { return a.doc - b.doc; })
        .forEach(function (u) { wrap.appendChild(u.span); });

      svg.remove();
    }

    wrap.dataset.rollInit = 'true';

    var hinges = units.map(function (u) { return u.hinge; });
    // Opacity goes on the leaf SVG, not the wrappers: an opacity below 1 is a
    // grouping property and would flatten preserve-3d on its subtree, killing
    // the perspective for as long as the fade runs.
    var faces = units.map(function (u) { return u.face; });

    // Park the wordmark in its pre-roll pose now, so the wait below can never
    // show a finished mark that then jumps back to flat.
    gsap.set(hinges, { transformPerspective: P.perspective, rotateX: P.startRotation });
    gsap.set(faces, { opacity: 0 });

    whenPainted(noiseSrc, function () {
      var tl = gsap.timeline({
        defaults: { duration: P.duration, ease: P.ease },
        scrollTrigger: {
          trigger: wrap,
          start: 'top 90%',
          end: 'bottom 75%',
          invalidateOnRefresh: true,
          toggleActions: 'restart none none reset'
        }
      });

      // Pure hinge: rotateX only. No yPercent, no clip-path — those produce
      // vertical travel and unpin the baseline.
      tl.fromTo(hinges,
        { transformPerspective: P.perspective, rotateX: P.startRotation },
        { transformPerspective: P.perspective, rotateX: 0, stagger: P.stagger }
      );

      // Short fade so letters aren't a hard pop at the edge-on start frame.
      tl.fromTo(faces,
        { opacity: 0 },
        { opacity: 1, duration: P.duration / 3, ease: 'power1.out', stagger: P.stagger },
        '<'
      );

      tl.timeScale(P.slowMo);
      ScrollTrigger.refresh();
    });

    return true;
  }

  // Resolves once the noise bitmap is in the cache and will paint. The same URL
  // the <image> already requested, so this is a cache hit, not a second fetch.
  // Times out rather than letting a stalled image hide the wordmark forever.
  function whenPainted(src, cb) {
    if (!src) return cb();
    var fired = false;
    function go() {
      if (fired) return;
      fired = true;
      cb();
    }
    var img = new Image();
    img.onload = go;
    img.onerror = go;
    img.src = src;
    if (img.complete) go();
    setTimeout(go, 3000);
  }

  function refresh() {
    if (window.ScrollTrigger) ScrollTrigger.refresh();
  }

  // The wordmark is the last thing on the page, so its scroll position is only
  // trustworthy once everything above it has loaded. On a cold load the images
  // higher up have no height yet, the page measures far shorter than it ends up,
  // and 'top 90%' reads as already-in-view — so the roll plays instantly while
  // you're still at the top and is over before you scroll down. A reload serves
  // those images from cache, the layout is right at DOMContentLoaded, and it
  // looks fine. Building early keeps the mark from flashing unbuilt; the refresh
  // on window load is what re-measures the trigger against the settled page.
  //
  // The retry also covers the two other silent bails: gsap/ScrollTrigger are
  // deferred scripts that may not have executed yet, and getBBox() returns 0
  // until the SVG has actually been laid out.
  function boot(attempt) {
    if (window.gsap && window.ScrollTrigger && init()) {
      if (document.readyState === 'complete') refresh();
      else window.addEventListener('load', refresh, { once: true });
      return;
    }
    if (attempt < 120) requestAnimationFrame(function () { boot(attempt + 1); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(0); });
  } else {
    boot(0);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["script-gallery"] && !Shopify.designMode) return;
  try {
    /*
 * Gallery slider — Swiper with natural-width slides at a fixed row height.
 * Shared by the gallery section and the player page.
 * Hooks: [data-gallery], [data-gallery-slider], [data-gallery-prev], [data-gallery-next]
 */

(function () {
  function initGallery(root) {
    if (root.dataset.galleryInit === 'true') return;
    root.dataset.galleryInit = 'true';

    const el = root.querySelector('[data-gallery-slider]');
    if (!el || !window.Swiper) return;

    const slideCount = el.querySelectorAll('.swiper-slide').length;
    const loop = slideCount >= 5;
    const mousewheel = {
      enabled: false,
      forceToAxis: loop,
      releaseOnEdges: true,
    };

    new window.Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 20,
      speed: 400,
      loop: loop,
      loopAdditionalSlides: 3,
      rewind: !loop,
      watchSlidesProgress: true,
      freeMode: { enabled: false },
      mousewheel: mousewheel,
      navigation: {
        prevEl: root.querySelector('[data-gallery-prev]'),
        nextEl: root.querySelector('[data-gallery-next]'),
        disabledClass: 'is-disabled',
      },
      breakpoints: {
        992: {
          freeMode: { enabled: true, momentumBounce: false },
          mousewheel: {
            enabled: true,
            forceToAxis: loop,
            releaseOnEdges: true,
          },
        },
      },
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-gallery]').forEach(function (root) {
      root.dataset.galleryInit = 'false';
      initGallery(root);
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["script-key-dates"] && !Shopify.designMode) return;
  try {
    /*
 * Key dates — step card slider. Mobile/tablet only: fixed-width slides that
 * bleed past the site margin. From 992 the Swiper is destroyed and the
 * wrapper falls back to the CSS centred row.
 * Swiper is loaded globally in theme.liquid.
 * Hooks: [data-kd-slider]
 */

(function () {
  const DESKTOP = window.matchMedia('(min-width: 992px)');
  const instances = new WeakMap();

  function sync(el) {
    if (!window.Swiper) return;

    if (DESKTOP.matches) {
      const swiper = instances.get(el);
      if (swiper) {
        swiper.destroy(true, true);
        instances.delete(el);
      }
      return;
    }

    if (instances.has(el)) return;

    instances.set(
      el,
      new window.Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 24,
        speed: 400,
        grabCursor: true,
        watchOverflow: true,
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
        },
      })
    );
  }

  function syncAll(scope) {
    (scope || document).querySelectorAll('[data-kd-slider]').forEach(sync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncAll();
    });
  } else {
    syncAll();
  }

  DESKTOP.addEventListener('change', function () {
    syncAll();
  });

  document.addEventListener('shopify:section:load', function (e) {
    syncAll(e.target);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["script-landing-banner"] && !Shopify.designMode) return;
  try {
    /*
 * Landing banner — SplitText line reveal + slide carousel + video visibility gate
 * + fixture-card countdown.
 * Hooks: [data-lb-heading], [data-lb-delay], [data-lb-carousel], [data-lb-video],
 *        [data-countdown-to] (with [data-unit] children)
 */

(function () {
  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  // Ticks the fixture card's Days/Hours/Mins/Sec down to kick-off. At zero it
  // reloads so the server re-renders the Live state (or rolls to the next match).
  function initCountdown(el) {
    if (el.dataset.cdInit === 'true') return;
    el.dataset.cdInit = 'true';

    const target = parseInt(el.dataset.countdownTo, 10) * 1000;
    if (!target) return;

    const fig = {
      days: el.querySelector('[data-unit="days"]'),
      hours: el.querySelector('[data-unit="hours"]'),
      mins: el.querySelector('[data-unit="mins"]'),
      secs: el.querySelector('[data-unit="secs"]'),
    };

    let timer;
    function tick() {
      const diff = Math.floor((target - Date.now()) / 1000);
      if (diff <= 0) {
        clearInterval(timer);
        window.location.reload();
        return;
      }
      if (fig.days) fig.days.textContent = Math.floor(diff / 86400);
      if (fig.hours) fig.hours.textContent = pad(Math.floor((diff % 86400) / 3600));
      if (fig.mins) fig.mins.textContent = pad(Math.floor((diff % 3600) / 60));
      if (fig.secs) fig.secs.textContent = pad(diff % 60);
    }

    tick();
    timer = setInterval(tick, 1000);
  }

  function revealHeading(heading) {
    if (heading.dataset.lbInit === 'true') return;
    heading.dataset.lbInit = 'true';

    const canAnimate =
      !REDUCED.matches && typeof gsap !== 'undefined' && typeof SplitText !== 'undefined';

    if (!canAnimate) {
      heading.style.visibility = 'visible';
      return;
    }

    gsap.registerPlugin(SplitText);

    const delay = parseFloat(heading.dataset.lbDelay);
    // aria: 'none' — SplitText's default ('auto') puts an aria-label on the
    // target and aria-hidden on the lines, but aria-label is prohibited on a
    // <p> (role=paragraph). The split lines keep the text in reading order, so
    // screen readers get the heading either way.
    const split = new SplitText(heading, {
      type: 'lines',
      mask: 'lines',
      linesClass: 'split-line',
      aria: 'none',
    });

    gsap
      .timeline({ delay: isNaN(delay) ? 0 : delay })
      .set(heading, { autoAlpha: 1 })
      .set(split.lines, { yPercent: 110 }, 0)
      .to(split.lines, { yPercent: 0, duration: 0.8, ease: 'power3.out', stagger: 0.06 }, 0);
  }

  function initCarousel(el) {
    if (el.dataset.lbInit === 'true' || !window.Swiper) return;
    el.dataset.lbInit = 'true';

    new window.Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 24,
      // Mobile snaps one slide per swipe; desktop keeps the free/mousewheel scroll.
      freeMode: { enabled: false },
      slidesPerGroup: 1,
      speed: 400,
      watchOverflow: true,
      mousewheel: {
        forceToAxis: true,
        releaseOnEdges: true,
      },
      breakpoints: {
        992: {
          freeMode: { enabled: true },
        },
      },
    });
  }

  function initVideo(video) {
    if (video.dataset.lbInit === 'true') return;
    video.dataset.lbInit = 'true';

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    });
    observer.observe(video);
  }

  function init(root = document) {
    root.querySelectorAll('[data-lb-heading]').forEach(revealHeading);
    root.querySelectorAll('[data-lb-carousel]').forEach(initCarousel);
    root.querySelectorAll('[data-lb-video]').forEach(initVideo);
    root.querySelectorAll('[data-countdown-to]').forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["script-latest-news"] && !Shopify.designMode) return;
  try {
    /*
 * Latest news slider. Mobile/tablet only — ~1.08 peek slides. From 992 the
 * Swiper is destroyed and the wrapper falls back to the CSS 4-column grid.
 * Swiper is loaded globally in theme.liquid.
 * Hooks: [data-ln-slider]
 */

(function () {
  const DESKTOP = window.matchMedia('(min-width: 992px)');
  const instances = new WeakMap();

  function sync(el) {
    if (!window.Swiper) return;

    if (DESKTOP.matches) {
      const swiper = instances.get(el);
      if (swiper) {
        swiper.destroy(true, true);
        instances.delete(el);
      }
      return;
    }

    if (instances.has(el)) return;

    instances.set(
      el,
      new window.Swiper(el, {
        slidesPerView: 1.08,
        spaceBetween: 24,
        speed: 400,
        breakpoints: {
          768: { slidesPerView: 2.2, spaceBetween: 24 },
        },
      })
    );
  }

  function syncAll(scope) {
    (scope || document).querySelectorAll('[data-ln-slider]').forEach(sync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncAll();
    });
  } else {
    syncAll();
  }

  DESKTOP.addEventListener('change', function () {
    syncAll();
  });

  document.addEventListener('shopify:section:load', function (e) {
    syncAll(e.target);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["script-legal-content"] && !Shopify.designMode) return;
  try {
    /*
 * section-legal-content.js — Sharks
 * Tabbed legal content. Dynamic theme blocks aren't iterable in Liquid, so the
 * sidebar tab buttons are built here from the rendered panels ([data-legal-panel],
 * [data-legal-title]). Panels start hidden (CSS); first tab opens on init.
 * No-JS: panels are all revealed and the (empty) tab nav stays hidden.
 * Hooks: [data-legal-nav], [data-legal-nav-toggle], [data-legal-current],
 *        [data-legal-tablist], [data-legal-panel].
 */
(function () {
  function initSection(root) {
    if (root.dataset.legalInit) return;
    root.dataset.legalInit = 'true';

    var nav = root.querySelector('[data-legal-nav]');
    var tablist = root.querySelector('[data-legal-tablist]');
    var trigger = root.querySelector('[data-legal-nav-toggle]');
    var current = root.querySelector('[data-legal-current]');
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-legal-panel]'));
    if (!nav || !tablist || !panels.length) return;

    // Build a tab button per panel.
    var tabs = panels.map(function (panel) {
      var id = panel.dataset.legalPanel;
      var title = panel.dataset.legalTitle || (panel.querySelector('.legal-content_title') || {}).textContent || '';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'legal-content_tab';
      btn.setAttribute('role', 'tab');
      btn.id = 'tab-' + id;
      btn.setAttribute('aria-controls', 'panel-' + id);
      btn.setAttribute('aria-selected', 'false');
      btn.dataset.legalTab = id;
      var label = document.createElement('span');
      label.className = 'legal-content_tab-label';
      label.textContent = title;
      btn.appendChild(label);
      tablist.appendChild(btn);
      return btn;
    });

    nav.removeAttribute('hidden');

    function setOpen(open) {
      nav.classList.toggle('is-open', open);
      if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function activate(id) {
      tabs.forEach(function (tab) {
        var on = tab.dataset.legalTab === id;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on && current) current.textContent = tab.querySelector('.legal-content_tab-label').textContent;
      });
      panels.forEach(function (panel) {
        panel.classList.toggle('is-active', panel.dataset.legalPanel === id);
      });
      setOpen(false);
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { activate(tab.dataset.legalTab); });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        if (!next) return;
        e.preventDefault();
        next.focus();
        activate(next.dataset.legalTab);
      });
    });

    if (trigger) {
      trigger.addEventListener('click', function () {
        setOpen(!nav.classList.contains('is-open'));
      });
    }
    document.addEventListener('click', function (event) {
      if (!nav.contains(event.target)) setOpen(false);
    });
    nav.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') setOpen(false);
    });

    activate(tabs[0].dataset.legalTab);
  }

  function init() {
    document.querySelectorAll('.section_legal-content').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = (e.target.classList && e.target.classList.contains('section_legal-content'))
      ? e.target : e.target.querySelector('.section_legal-content');
    if (root) {
      root.dataset.legalInit = '';
      var tablist = root.querySelector('[data-legal-tablist]');
      if (tablist) tablist.innerHTML = '';
      initSection(root);
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["script-main-blog"] && !Shopify.designMode) return;
  try {
    /*
 * Blog listing — Player Stories band Swiper slider.
 * Mobile: ~1.1 peek slides. Desktop (>=992): 3-up, reads as a static row.
 * Swiper is loaded globally in theme.liquid.
 * Hooks: [data-player-stories], [data-ps-slider]
 */

(function () {
  function initBand(root) {
    if (root.dataset.psInit === 'true') return;
    root.dataset.psInit = 'true';

    const el = root.querySelector('[data-ps-slider]');
    if (!el || !window.Swiper) return;

    new window.Swiper(el, {
      slidesPerView: 1.08,
      spaceBetween: 24,
      speed: 400,
      breakpoints: {
        992: { slidesPerView: 3, spaceBetween: 24 },
      },
    });
  }

  function init() {
    document.querySelectorAll('[data-player-stories]').forEach(initBand);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('[data-player-stories]');
    if (root) {
      root.dataset.psInit = 'false';
      initBand(root);
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["script-main-collection"] && !Shopify.designMode) return;
  try {
    /*
 * Collection listing — custom AJAX filtering (badge tags, colour, size, price band),
 * sort and pagination. Filters render server-side via the Section Rendering API;
 * the grid, filters and count are swapped in place. Sort select is TomSelect.
 * Hooks: [data-collection], [data-filter-input], [data-sort], [data-chip-remove],
 *        [data-filter-clear], [data-page-link], [data-filters], [data-results], [data-count]
 */

(function () {
  function initSort(root) {
    const select = root.querySelector('[data-sort]');
    if (!select || select.dataset.sortInit === 'true') return;
    if (typeof TomSelect === 'undefined') return;
    select.dataset.sortInit = 'true';

    new TomSelect(select, {
      controlInput: null,
      create: false,
      allowEmptyOption: true,
      hideSelected: false,
      render: {
        item: () => '<div class="text-s text-s-bold text-upper">Sort by</div>',
      },
    });
  }

  function initCollection(root) {
    if (root.dataset.colInit === 'true') return;
    root.dataset.colInit = 'true';

    const baseUrl = root.dataset.collectionUrl;
    const sectionId = root.dataset.sectionId;

    initSort(root);
    updateFilterCount();

    // Every active filter renders as a checked input, so counting them matches
    // the sidebar's own active_total without duplicating its badge:* rules.
    function updateFilterCount() {
      const n = root.querySelectorAll('[data-filters] [data-filter-input]:checked').length;
      root.querySelectorAll('[data-filter-count]').forEach((badge) => {
        badge.textContent = n > 0 ? n : '';
        badge.hidden = n === 0;
      });
    }

    // Drawer state lives on the root, not the sidebar — the sidebar element is
    // replaced on every render, which would drop a class set on it.
    function toggleFilters(force) {
      const open = force === undefined ? !root.classList.contains('filters-open') : force;
      root.classList.toggle('filters-open', open);
      document.body.classList.toggle('has-drawer-open', open);
    }

    // Native Shopify filter params. Multi-select repeats the key
    // (filter.v.option.colour=Black&filter.v.option.colour=White) — never comma-joined.
    function buildUrl() {
      const params = new URLSearchParams();

      root.querySelectorAll('input[data-filter-input]:checked').forEach((el) => {
        if (el.name) params.append(el.name, el.value);
      });

      const sort = root.querySelector('[data-sort]');
      if (sort && sort.value) params.set('sort_by', sort.value);

      const qs = params.toString();
      return baseUrl + (qs ? '?' + qs : '');
    }

    // Paging is AJAX, so the browser never scrolls — after a page swap the
    // shopper is left at the bottom of the old grid, looking at the pagination
    // instead of the new products. Bring them back to the top of the listing.
    // The header is `position: fixed`, so offset by its height or the first row
    // of cards sits underneath it.
    function scrollToListing() {
      const header = document.querySelector('.header_main');
      const offset = (header ? header.offsetHeight : 0) + 16;
      const top = window.scrollY + root.getBoundingClientRect().top - offset;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: Math.max(0, top), behavior: reduced ? 'auto' : 'smooth' });
    }

    async function render(url, push, scrollUp) {
      root.classList.add('is-loading');
      try {
        const fetchUrl = new URL(url, window.location.origin);
        fetchUrl.searchParams.set('section_id', sectionId);
        const res = await fetch(fetchUrl.pathname + fetchUrl.search);
        const text = await res.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');

        ['[data-filters]', '[data-results]', '[data-count]'].forEach((sel) => {
          const oldEl = root.querySelector(sel);
          const newEl = doc.querySelector(sel);
          if (oldEl && newEl) oldEl.replaceWith(newEl);
        });

        updateFilterCount();

        if (scrollUp) scrollToListing();

        if (push !== false) {
          const clean = new URL(url, window.location.origin);
          clean.searchParams.delete('section_id');
          window.history.pushState({}, '', clean.pathname + clean.search);
        }
      } catch (e) {
        window.location.href = url;
      } finally {
        root.classList.remove('is-loading');
      }
    }

    root.addEventListener('change', (e) => {
      if (e.target.matches('[data-filter-input], [data-sort]')) render(buildUrl());
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && root.classList.contains('filters-open')) toggleFilters(false);
    });

    root.addEventListener('click', (e) => {
      if (e.target.closest('[data-filters-toggle]')) {
        toggleFilters();
        return;
      }

      if (e.target.closest('[data-filters-close]')) {
        toggleFilters(false);
        return;
      }

      const link = e.target.closest('[data-filter-remove], [data-filter-clear], [data-page-link]');
      if (link) {
        e.preventDefault();
        // Only paging needs the scroll — a filter/chip is clicked from the top
        // of the listing already, and yanking the page would be jarring.
        render(link.getAttribute('href'), true, link.matches('[data-page-link]'));
      }
    });

    window.addEventListener('popstate', () => render(window.location.href, false));
  }

  function init() {
    document.querySelectorAll('[data-collection]').forEach(initCollection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('[data-collection]');
    if (root) { root.dataset.colInit = 'false'; initCollection(root); }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["script-main-player"] && !Shopify.designMode) return;
  try {
    /*
 * Player bio — mobile "read more" accordion.
 * On mobile the bio is clamped to 7 lines; if it overflows, a toggle reveals
 * the rest and switches to "Read less". Desktop always shows the full bio.
 * Hooks: [data-player-bio], [data-bio-text], [data-bio-toggle]
 */

(function () {
  var mq = window.matchMedia('(max-width: 991px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initBio(root) {
    if (root.dataset.pbInit === 'true') return;
    root.dataset.pbInit = 'true';

    var text = root.querySelector('[data-bio-text]');
    var toggle = root.querySelector('[data-bio-toggle]');
    if (!text || !toggle) return;

    // Show the toggle only when the clamped bio actually overflows on mobile.
    function evaluate() {
      if (!mq.matches) {
        // Off mobile the clamp doesn't apply — clear any inline height.
        root.classList.remove('has-overflow');
        text.style.maxHeight = '';
        return;
      }
      if (root.classList.contains('is-expanded')) return;
      root.classList.toggle('has-overflow', text.scrollHeight > text.clientHeight + 1);
    }

    // Once the open animation finishes, drop the fixed height so later
    // reflows (font load, resize) aren't clipped.
    text.addEventListener('transitionend', function (e) {
      if (e.propertyName === 'max-height' && root.classList.contains('is-expanded')) {
        text.style.maxHeight = 'none';
      }
    });

    toggle.addEventListener('click', function () {
      var expanded = !root.classList.contains('is-expanded');
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');

      // Anchor a concrete pixel height so max-height can transition either way.
      text.style.maxHeight = text.scrollHeight + 'px';

      if (expanded) {
        root.classList.add('is-expanded');
        // No transition fires with reduced motion, so settle the height now.
        if (reduce.matches) text.style.maxHeight = 'none';
      } else {
        // Force the reflow, then fall back to the CSS clamp to animate closed.
        void text.offsetHeight;
        root.classList.remove('is-expanded');
        text.style.maxHeight = '';
      }
    });

    evaluate();

    var raf;
    window.addEventListener('resize', function () {
      window.cancelAnimationFrame(raf);
      raf = window.requestAnimationFrame(evaluate);
    });
  }

  function init() {
    document.querySelectorAll('[data-player-bio]').forEach(initBio);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-player-bio]');
    if (root) {
      root.dataset.pbInit = 'false';
      initBio(root);
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["script-match-banner"] && !Shopify.designMode) return;
  try {
    /*
 * Match banner countdown. Ticks the Days/Hours/Mins/Sec figures down to the
 * match's kick-off (epoch seconds in data-countdown-to). At zero it reloads so
 * the server re-renders the Live state.
 * Hooks: [data-countdown-to], [data-unit]
 */

(function () {
  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function initCountdown(el) {
    if (el.dataset.cdInit === 'true') return;
    el.dataset.cdInit = 'true';

    var target = parseInt(el.dataset.countdownTo, 10) * 1000;
    if (!target) return;

    var fig = {
      days: el.querySelector('[data-unit="days"]'),
      hours: el.querySelector('[data-unit="hours"]'),
      mins: el.querySelector('[data-unit="mins"]'),
      secs: el.querySelector('[data-unit="secs"]'),
    };

    function tick() {
      var diff = Math.floor((target - Date.now()) / 1000);
      if (diff <= 0) {
        clearInterval(timer);
        // Kick-off reached — re-render as Live.
        window.location.reload();
        return;
      }
      var d = Math.floor(diff / 86400);
      var h = Math.floor((diff % 86400) / 3600);
      var m = Math.floor((diff % 3600) / 60);
      var s = diff % 60;
      if (fig.days) fig.days.textContent = d;
      if (fig.hours) fig.hours.textContent = pad(h);
      if (fig.mins) fig.mins.textContent = pad(m);
      if (fig.secs) fig.secs.textContent = pad(s);
    }

    tick();
    var timer = setInterval(tick, 1000);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-countdown-to]').forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["script-match-news"] && !Shopify.designMode) return;
  try {
    /*
 * Match News — a single drag/scroll news slider (auto-width cards, no arrows),
 * matching the Featured Products slider. Swiper is loaded globally in theme.liquid.
 * Hooks: [data-match-news], [data-mn-swiper]
 */

(function () {
  function initSlider(el) {
    if (el.dataset.mnInit === 'true' || !window.Swiper) return;
    el.dataset.mnInit = 'true';

    new window.Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 24,
      speed: 400,
      grabCursor: true,
      observer: true,
      observeParents: true,
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-mn-swiper]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["script-membership-options"] && !Shopify.designMode) return;
  try {
    /*
 * Membership options. Peek carousel of package cards below 992, destroyed above
 * it so the wrapper falls back to the CSS stacked column. Also drives the
 * benefits modals. Swiper is loaded globally in theme.liquid.
 * Hooks: [data-packages-slider], [data-package-open], [data-package-close]
 */

(function () {
  const DESKTOP = window.matchMedia('(min-width: 992px)');
  const FOCUSABLE = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
  const DURATION = 300;
  const instances = new WeakMap();
  const timers = new WeakMap();
  let openModal = null;
  let lastTrigger = null;

  function syncSlider(el) {
    if (!window.Swiper) return;

    if (DESKTOP.matches) {
      const swiper = instances.get(el);
      if (swiper) {
        swiper.destroy(true, true);
        instances.delete(el);
      }
      return;
    }

    if (instances.has(el)) return;

    instances.set(
      el,
      new window.Swiper(el, {
        slidesPerView: 1.08,
        spaceBetween: 24,
        speed: 400,
        breakpoints: {
          768: { slidesPerView: 2.2, spaceBetween: 24 },
        },
      })
    );
  }

  function reduced() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function hide(modal, instant) {
    window.clearTimeout(timers.get(modal));
    modal.classList.remove('is-open');
    if (instant) {
      modal.setAttribute('hidden', '');
      return;
    }
    timers.set(
      modal,
      window.setTimeout(function () {
        modal.setAttribute('hidden', '');
      }, DURATION)
    );
  }

  function close() {
    if (!openModal) return;
    hide(openModal, reduced());
    openModal = null;
    document.body.style.overflow = '';
    if (lastTrigger) {
      lastTrigger.focus();
      lastTrigger = null;
    }
  }

  function open(id, trigger) {
    const modal = document.getElementById(id);
    if (!modal) return;

    close();
    window.clearTimeout(timers.get(modal));
    lastTrigger = trigger;
    openModal = modal;
    modal.classList.toggle('is-instant', reduced());
    modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';

    if (reduced()) {
      modal.classList.add('is-open');
    } else {
      // Two frames so the browser paints the closed state before transitioning.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          modal.classList.add('is-open');
        });
      });
    }

    const first = modal.querySelector(FOCUSABLE);
    if (first) first.focus();
  }

  function trapFocus(event) {
    if (event.key !== 'Tab' || !openModal) return;

    const items = Array.from(openModal.querySelectorAll(FOCUSABLE)).filter(function (el) {
      return el.offsetParent !== null;
    });
    if (!items.length) return;

    const first = items[0];
    const last = items[items.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function syncAll(scope) {
    (scope || document).querySelectorAll('[data-packages-slider]').forEach(syncSlider);
  }

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-package-open]');
    if (trigger) {
      open(trigger.getAttribute('data-package-open'), trigger);
      return;
    }
    if (event.target.closest('[data-package-close]')) close();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') close();
    trapFocus(event);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncAll();
    });
  } else {
    syncAll();
  }

  DESKTOP.addEventListener('change', function () {
    syncAll();
  });

  document.addEventListener('shopify:section:load', function (e) {
    syncAll(e.target);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["script-product-carousel"] && !Shopify.designMode) return;
  try {
    /*
 * Product carousel — Swiper with fixed-width slides that bleed off the
 * right edge.
 * Hooks: [data-product-carousel], [data-pc-slider]
 */

(function () {
  function initCarousel(root) {
    if (root.dataset.pcInit === 'true') return;
    root.dataset.pcInit = 'true';

    const el = root.querySelector('[data-pc-slider]');
    if (!el || !window.Swiper) return;

    new window.Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 24,
      speed: 400,
      /* Centre the row when the slides don't fill the track. Swiper's own
         option, not CSS: centring .swiper-wrapper with flex moves the slides
         out from under the transform Swiper positions them with, so its snap
         points and drag bounds stop matching what's on screen. This shifts the
         translate instead, which keeps that maths intact. No effect once there
         are enough slides to overflow. */
      centerInsufficientSlides: true,
      mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
        },
    });
  }

  function init() {
    document.querySelectorAll('[data-product-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('[data-product-carousel]');
    if (root) {
      root.dataset.pcInit = 'false';
      initCarousel(root);
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["script-product-hero"] && !Shopify.designMode) return;
  try {
    /*
 * Product hero — media gallery, thumbnails, lightbox, and the ?variant= URL sync.
 * Variant selection / price / quantity / add-to-cart live in
 * component-product-purchase.js; this file just reacts to its "variant:change".
 *
 * Hooks: [data-product-hero], [data-slider], [data-thumb], [data-thumbs-scroll],
 *        [data-zoom]
 */

(function () {
  function initHero(root) {
    if (root.dataset.heroInit === 'true') return;
    root.dataset.heroInit = 'true';

    /* ----- Media gallery (Swiper slider; thumbnails drive it on desktop) ----- */
    const sliderEl = root.querySelector('[data-slider]');
    const thumbs = Array.from(root.querySelectorAll('[data-thumb]'));
    let swiper = null;

    function setActiveThumb(index) {
      thumbs.forEach((t) => t.classList.toggle('is-active', parseInt(t.dataset.thumb, 10) === index));
    }

    function showSlide(index) {
      if (swiper) swiper.slideTo(index);
      else setActiveThumb(index);
    }

    if (sliderEl && window.Swiper) {
      swiper = new window.Swiper(sliderEl, {
        slidesPerView: 1.085,
        spaceBetween: 16,
        speed: 400,
        breakpoints: {
          769: { slidesPerView: 1, spaceBetween: 0 },
        },
        on: {
          slideChange: function () { setActiveThumb(this.activeIndex); },
        },
      });
      setActiveThumb(swiper.activeIndex);
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => showSlide(parseInt(thumb.dataset.thumb, 10)));
    });

    /* ----- Thumbnail column overflow ----------------------------------------
       The column is capped at the stage's height in CSS, so a long list
       scrolls. Flag whether there is anything left to reach so the bottom fade
       only shows while it is true — no fade when the list already fits, and
       none once you are at the end. The column is display:none below desktop,
       where clientHeight is 0 and both flags stay false. */
    const thumbsScroll = root.querySelector('[data-thumbs-scroll]');
    if (thumbsScroll) {
      const shell = thumbsScroll.parentElement;

      const syncThumbOverflow = () => {
        const scrollable = thumbsScroll.scrollHeight - thumbsScroll.clientHeight > 1;
        const atEnd =
          thumbsScroll.scrollTop + thumbsScroll.clientHeight >= thumbsScroll.scrollHeight - 1;
        shell.classList.toggle('is-scrollable', scrollable);
        shell.classList.toggle('is-at-end', scrollable && atEnd);
      };

      thumbsScroll.addEventListener('scroll', syncThumbOverflow, { passive: true });
      window.addEventListener(
        'resize',
        typeof debounce === 'function' ? debounce(syncThumbOverflow) : syncThumbOverflow
      );
      syncThumbOverflow();
    }

    /* ----- React to variant changes from the shared purchase form ----- */
    root.addEventListener('variant:change', (e) => {
      const variant = e.detail && e.detail.variant;
      if (!variant) return;

      if (variant.featured_media) showSlide(variant.featured_media.position - 1);

      if (window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    });

    /* ----- Lightbox ----- */
    const zoom = root.querySelector('[data-zoom]');
    if (zoom) {
      zoom.addEventListener('click', () => {
        const active = root.querySelector('.swiper-slide-active img') || root.querySelector('.product-hero_slide img');
        if (!active) return;
        const box = document.createElement('div');
        box.className = 'product-hero_lightbox';
        const img = document.createElement('img');
        img.src = active.currentSrc || active.src;
        img.alt = active.alt || '';
        box.appendChild(img);
        const close = () => box.remove();
        box.addEventListener('click', close);
        document.addEventListener('keydown', function esc(e) {
          if (e.key === 'Escape') { close(); document.removeEventListener('keydown', esc); }
        });
        document.body.appendChild(box);
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-product-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('[data-product-hero]');
    if (root) { root.dataset.heroInit = 'false'; initHero(root); }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["script-product-purchase"] && !Shopify.designMode) return;
  try {
    /*
 * Product purchase form — variant selection, price, quantity, add-to-cart.
 * Shared by the PDP (product-hero) and featured product tabs.
 *
 * Binds to [data-product-purchase]. Hooks: [data-option-input], [data-variant-id],
 * [data-price], [data-submit], [data-qty-*], [data-cart-error],
 * and optionally [data-badge-sale] / [data-badge-oos] anywhere in the owning section.
 *
 * Emits: "variant:change" (bubbles) with detail { variant, priceData } so owners
 * can react — e.g. the PDP moves its gallery — without this file knowing about them.
 */

(function () {
  function readJSON(el) {
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  function initPurchase(root) {
    if (root.dataset.purchaseInit === 'true') return;
    root.dataset.purchaseInit = 'true';

    const variants = readJSON(root.querySelector('[data-variants]'));
    const prices = readJSON(root.querySelector('[data-prices]'));
    const form = root.querySelector('.product-purchase_form');
    const idInput = root.querySelector('[data-variant-id]');
    const priceEl = root.querySelector('[data-price]');
    const submit = root.querySelector('[data-submit]');
    const submitText = root.querySelector('[data-submit-text]');
    const errorEl = root.querySelector('[data-cart-error]');
    const optionInputs = Array.from(root.querySelectorAll('[data-option-input]'));

    // Badges live outside this snippet (the PDP puts them over the gallery),
    // so look them up in the owning section rather than in root.
    const owner = root.closest('[data-product-scope]') || root;
    const saleBadge = owner.querySelector('[data-badge-sale]');
    const oosBadge = owner.querySelector('[data-badge-oos]');

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg || '';
      errorEl.hidden = !msg;
    }

    /* ----- Variant selection ----- */
    function selectedOptions() {
      const values = [];
      root.querySelectorAll('[data-option]').forEach((fieldset) => {
        const pos = parseInt(fieldset.dataset.optionPosition, 10);
        const select = fieldset.querySelector('select[data-option-input]');
        if (select) {
          values[pos - 1] = select.value || null;
          return;
        }
        const checked = fieldset.querySelector('[data-option-input]:checked');
        values[pos - 1] = checked ? checked.value : null;
      });
      return values;
    }

    function findVariant(values) {
      return variants.find((v) => v.options.every((opt, i) => opt === values[i]));
    }

    function updateAvailability(values) {
      root.querySelectorAll('[data-option]').forEach((fieldset) => {
        const pos = parseInt(fieldset.dataset.optionPosition, 10);
        // Dropdown options have no label to mark up; skip them.
        if (fieldset.querySelector('select[data-option-input]')) return;
        fieldset.querySelectorAll('[data-option-input]').forEach((input) => {
          const trial = values.slice();
          trial[pos - 1] = input.value;
          const match = variants.some((v) =>
            v.available && v.options.every((opt, i) => trial[i] == null || opt === trial[i])
          );
          const label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !match);
        });
      });
    }

    function updateSelectedLabels() {
      root.querySelectorAll('[data-option]').forEach((fieldset) => {
        const out = fieldset.querySelector('[data-option-selected]');
        if (!out) return;
        const select = fieldset.querySelector('select[data-option-input]');
        const checked = fieldset.querySelector('[data-option-input]:checked');
        if (select) out.textContent = select.value;
        else if (checked) out.textContent = checked.value;
      });
    }

    function onOptionChange() {
      const values = selectedOptions();
      updateSelectedLabels();
      updateAvailability(values);

      const variant = findVariant(values);
      if (!variant) {
        if (submit) submit.disabled = true;
        if (submitText) submitText.textContent = 'Unavailable';
        return;
      }

      if (idInput) idInput.value = variant.id;

      const priceData = prices[variant.id];
      if (priceEl && priceData) priceEl.innerHTML = priceData.html;
      if (saleBadge) saleBadge.hidden = !(priceData && priceData.on_sale && variant.available);
      if (oosBadge) oosBadge.hidden = variant.available;

      applyAvailability(variant);

      root.dispatchEvent(new CustomEvent('variant:change', {
        bubbles: true,
        detail: { variant: variant, priceData: priceData },
      }));
    }

    optionInputs.forEach((input) => input.addEventListener('change', onOptionChange));
    if (optionInputs.length) updateAvailability(selectedOptions());

    /* ----- Tom Select on dropdown options (e.g. Back Print) -----
     * Tom Select keeps the original <select> in the DOM and re-dispatches a
     * native "change" on it, so the listener above keeps working untouched. */
    root.querySelectorAll('select[data-option-input]').forEach((select) => {
      if (typeof TomSelect === 'undefined') return;
      if (select.dataset.tsInit === 'true') return;
      select.dataset.tsInit = 'true';
      new TomSelect(select, {
        controlInput: null,
        create: false,
        allowEmptyOption: true,
        hideSelected: false,
      });
    });

    /* ----- Quantity ----- */
    const qtyInput = root.querySelector('[data-qty-input]');
    const minus = root.querySelector('[data-qty-minus]');
    const plus = root.querySelector('[data-qty-plus]');

    /* What's already in the cart counts against the stock ceiling, or a shopper
       holding the last unit could add it again. `in_cart` is rendered with the
       page, so adds made since then are tracked here to keep it accurate
       without a reload. */
    const addedSinceLoad = {};

    function variantMax(variant) {
      const inv = variant && prices[variant.id];
      if (inv && inv.management === 'shopify' && inv.policy !== 'continue') {
        const held = (inv.in_cart || 0) + (addedSinceLoad[variant.id] || 0);
        return Math.max(0, (inv.quantity || 0) - held);
      }
      return Infinity;
    }

    function clampQty() {
      if (!qtyInput) return;
      const max = qtyInput.max ? parseInt(qtyInput.max, 10) : Infinity;
      let val = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      if (Number.isFinite(max) && max >= 1) val = Math.min(val, max);
      qtyInput.value = val;
    }

    function applyQtyMax(variant) {
      if (!qtyInput) return;
      const max = variantMax(variant);
      if (Number.isFinite(max) && max > 0) qtyInput.max = max;
      else qtyInput.removeAttribute('max');
      clampQty();
    }

    /* Single source of truth for the buy controls: out of stock, or in stock
       but the cart already holds every remaining unit. */
    function applyAvailability(variant) {
      const remaining = variantMax(variant);
      const maxed = variant.available && Number.isFinite(remaining) && remaining < 1;
      const canAdd = variant.available && !maxed;

      if (submit) submit.disabled = !canAdd;
      // Label tracks stock only — a maxed-out variant keeps "Add to Bag" and
      // just goes disabled.
      if (submitText) submitText.textContent = variant.available ? 'Add to Bag' : 'Out of Stock';

      applyQtyMax(variant);
      setQtyEnabled(canAdd);
    }

    function setQtyEnabled(enabled) {
      if (qtyInput) qtyInput.disabled = !enabled;
      if (minus) minus.disabled = !enabled;
      if (plus) plus.disabled = !enabled;
      const qtyWrap = root.querySelector('[data-qty]');
      if (qtyWrap) qtyWrap.classList.toggle('is-disabled', !enabled);
    }

    const stepQty = (delta) => {
      if (!qtyInput) return;
      const max = qtyInput.max ? parseInt(qtyInput.max, 10) : Infinity;
      let next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + delta);
      if (Number.isFinite(max) && max >= 1) next = Math.min(next, max);
      qtyInput.value = next;
    };

    if (minus) minus.addEventListener('click', () => stepQty(-1));
    if (plus) plus.addEventListener('click', () => stepQty(1));
    if (qtyInput) qtyInput.addEventListener('change', clampQty);

    const initVariant = findVariant(selectedOptions());
    if (initVariant) {
      applyAvailability(initVariant);
    } else {
      applyQtyMax(null);
      setQtyEnabled(true);
    }

    /* ----- Add to cart ----- */
    if (form) {
      form.addEventListener('submit', async (e) => {
        if (!window.routes || !window.routes.cart_add_url) return; // native submit fallback
        e.preventDefault();
        showError('');
        submit.classList.add('is-loading');
        submit.disabled = true;

        const formData = new FormData(form);
        const drawer = document.querySelector('.js-cart-drawer');
        if (drawer) formData.append('sections', 'cart-drawer');

        try {
          const res = await fetch(window.routes.cart_add_url, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: formData,
          });
          const data = await res.json();
          if (data.status) {
            showError(data.description || data.message || '');
            submit.classList.remove('is-loading');
            submit.disabled = false;
            return;
          }
          /* Count what just went in, so the ceiling drops immediately rather
             than staying on the in_cart figure rendered with the page. */
          const addedId = formData.get('id');
          const addedQty = Math.max(1, parseInt(formData.get('quantity'), 10) || 1);
          if (addedId) addedSinceLoad[addedId] = (addedSinceLoad[addedId] || 0) + addedQty;
          if (qtyInput) qtyInput.value = 1;

          // Update + open the Sidecar cart drawer (falls back to the cart page).
          if (drawer && typeof window.openCartDrawer === 'function') {
            const html = data.sections && data.sections['cart-drawer'];
            if (!(html && window.renderCartDrawerHTML && window.renderCartDrawerHTML(html))) {
              if (window.refreshCartDrawer) await window.refreshCartDrawer();
            }
            window.openCartDrawer();
          } else {
            window.location = window.routes.cart_url;
          }
        } catch (err) {
          form.submit();
        } finally {
          submit.classList.remove('is-loading');
          /* Re-derive rather than blindly re-enabling — after a successful add
             the variant may now be maxed out and must stay disabled. */
          const current = findVariant(selectedOptions());
          if (current) applyAvailability(current);
          else submit.disabled = false;
        }
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-product-purchase]').forEach(initPurchase);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('[data-product-purchase]').forEach((root) => {
      root.dataset.purchaseInit = 'false';
      initPurchase(root);
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["script-recommended-products"] && !Shopify.designMode) return;
  try {
    /*
 * Recommended products — Swiper slider. Mobile 1.1 peek slides; desktop N-up.
 * Hooks: [data-recommended-products], [data-rec-slider], data-columns
 */

(function () {
  function initRecommended(root) {
    if (root.dataset.recInit === 'true') return;
    root.dataset.recInit = 'true';

    const el = root.querySelector('[data-rec-slider]');
    if (!el || !window.Swiper) return;

    const cols = parseInt(el.dataset.columns, 10) || 4;
    new window.Swiper(el, {
      slidesPerView: 1.18,
      spaceBetween: 24,
      speed: 400,
      breakpoints: {
        769: { slidesPerView: cols, spaceBetween: 24 },
      },
    });
  }

  function init() {
    document.querySelectorAll('[data-recommended-products]').forEach(initRecommended);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('[data-recommended-products]');
    if (root) { root.dataset.recInit = 'false'; initRecommended(root); }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["script-share"] && !Shopify.designMode) return;
  try {
    /* ----- Share links --------------------------------------- *
 * Opens social share dialogs in a centred popup window.
 *
 * Progressive enhancement: every trigger is a real <a href> with
 * target="_blank", so sharing still works with JS disabled, if the script
 * fails, or if the popup is blocked.
 *
 * Markup contract:
 *   <a href="…" target="_blank" rel="noopener noreferrer"
 *      data-share-network="facebook|x|linkedin|whatsapp">
 *
 * Networks NOT listed in POPUP_SIZES (WhatsApp, mailto) deliberately navigate
 * normally — a popup breaks the mobile app hand-off / deep link.
 * ---------------------------------------------------------- */
(function () {
  // Delegated on document, so guard against a double-bind if the asset is
  // ever loaded by two sections on one page (would open two popups).
  if (window.sharksShareInit) return;
  window.sharksShareInit = true;

  var POPUP_SIZES = {
    facebook: { width: 600, height: 750 },
    x: { width: 600, height: 473 },
    twitter: { width: 600, height: 473 },
    linkedin: { width: 600, height: 563 },
    pinterest: { width: 750, height: 700 },
  };

  function openPopup(url, size) {
    // Centre on the CURRENT window rather than the primary screen — this is
    // what keeps it correct on multi-monitor setups.
    var dualLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    var dualTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
    var viewW = window.innerWidth || document.documentElement.clientWidth || screen.width;
    var viewH = window.innerHeight || document.documentElement.clientHeight || screen.height;

    var left = Math.round(dualLeft + (viewW - size.width) / 2);
    var top = Math.round(dualTop + (viewH - size.height) / 2);

    var features =
      'menubar=no,toolbar=no,status=no,resizable=yes,scrollbars=yes' +
      ',width=' + size.width +
      ',height=' + size.height +
      ',top=' + top +
      ',left=' + left;

    var popup = window.open(url, 'sharks-share', features);
    if (!popup) return false; // blocked → caller lets the link navigate instead
    popup.focus();
    return true;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-share-network]');
    if (!link) return;

    // Leave modified clicks alone so "open in new tab/window" still works.
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    var size = POPUP_SIZES[link.dataset.shareNetwork];
    if (!size) return; // whatsapp / mailto → normal navigation

    if (openPopup(link.href, size)) event.preventDefault();
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["script-tabbed-product-slider"] && !Shopify.designMode) return;
  try {
    /*
 * Tabbed product slider — one Swiper per tab, all rendered server-side and
 * toggled on click (no fetch). Swipers in hidden panels init at zero width,
 * so we update() a panel's swiper when its tab is shown.
 *
 * Hooks: [data-tabbed-product-slider], [data-tps-tab], [data-tps-panel],
 *        [data-tps-swiper]
 */

(function () {
  function initRoot(root) {
    if (root.dataset.tpsInit === 'true') return;
    root.dataset.tpsInit = 'true';

    const tabs = Array.from(root.querySelectorAll('[data-tps-tab]'));
    if (!tabs.length) return;

    // Build one Swiper per panel, keyed by the panel's block id.
    const swipers = {};
    root.querySelectorAll('[data-tps-panel]').forEach((panel) => {
      const el = panel.querySelector('[data-tps-swiper]');
      if (!el || !window.Swiper) return;
      swipers[panel.dataset.tpsPanel] = new window.Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 24,
        speed: 400,
        grabCursor: true,
        observer: true,
        observeParents: true,
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
        },
      });
    });

    function activate(id, animate) {
      tabs.forEach((tab) => {
        const on = tab.dataset.tpsTab === id;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-expanded', on ? 'true' : 'false');
      });

      root.querySelectorAll('[data-tps-panel]').forEach((panel) => {
        const on = panel.dataset.tpsPanel === id;
        panel.hidden = !on;
        // Replay the enter animation on the panel that's coming in.
        if (on && animate) {
          panel.classList.remove('is-entering');
          void panel.offsetWidth; // reflow so the animation can restart
          panel.classList.add('is-entering');
        }
      });

      // The now-visible swiper measured 0 while hidden — recalculate.
      if (swipers[id]) swipers[id].update();
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => activate(tab.dataset.tpsTab, true));
    });

    // Every panel renders hidden (a block can't know it's first), so open the
    // first tab now — no entrance animation on initial load.
    activate(tabs[0].dataset.tpsTab, false);
  }

  function init() {
    document.querySelectorAll('[data-tabbed-product-slider]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('[data-tabbed-product-slider]');
    if (root) {
      root.dataset.tpsInit = 'false';
      initRoot(root);
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["script-team-reveal"] && !Shopify.designMode) return;
  try {
    /* Team reveal — scroll-driven grid assembly.
 *
 * Pins the section and scrubs one GSAP timeline against scroll:
 *   - the centre IMAGE starts scaled up to fill the grid height, then settles
 *     into its cell;
 *   - the heading tweens its font-size (e.g. 135px -> 40px) crisply, decoupled
 *     from the image scale;
 *   - the 14 surrounding tiles fade + scale in, ordered by distance from the
 *     centre (nearest first) with a deterministic per-tile jitter so the reveal
 *     feels random but reverses cleanly when you scroll back up.
 *
 * GSAP + ScrollTrigger are loaded globally in layout/theme.liquid.
 */
(function () {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  // If Lenis is ever initialised globally, keep ScrollTrigger in sync with it.
  if (window.lenis && typeof window.lenis.on === 'function' && !window.__trLenisWired) {
    window.lenis.on('scroll', ScrollTrigger.update);
    window.__trLenisWired = true;
  }

  // Deterministic pseudo-random in [0,1) — stable across reloads & resizes so
  // the scrubbed timeline always reverses to the same frames.
  function seeded(n) {
    var x = Math.sin(n * 127.1 + 311.7) * 43758.5453;
    return x - Math.floor(x);
  }

  function setup(root) {
    if (root.__trInit) return;
    var grid = root.querySelector('[data-tr-grid]');
    var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-tr-tile]'));
    var center = root.querySelector('[data-tr-tile].is-center');
    var media = center && center.querySelector('[data-tr-media]');
    var heading = center && center.querySelector('[data-tr-heading]');
    var cta = center && center.querySelector('[data-tr-cta]');
    if (!grid || !center || !media || tiles.length < 2) return;

    // No animation for reduced-motion — the CSS fallback shows the final grid.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    root.__trInit = true;
    root.classList.add('tr--ready'); // CSS now hides the surrounding tiles

    var allOthers = tiles.filter(function (t) { return t !== center; });
    var tl = null;
    var mobilePlayed = false;

    function build() {
      // Mobile plays once and stays assembled. Don't tear the timeline down and
      // rebuild it (which would replay the reveal) — only a real breakpoint
      // change warrants that, and that's handled by the resize guard below.
      if (mobilePlayed) return;

      if (tl) { tl.scrollTrigger && tl.scrollTrigger.kill(); tl.kill(); tl = null; }

      // Only animate tiles that are actually laid out at this breakpoint — the
      // desktop-only tiles are display:none in the mobile 3x3 grid.
      var others = allOthers.filter(function (t) { return t.getClientRects().length > 0; });

      gsap.set(allOthers, { clearProps: 'transform,opacity,visibility' });
      gsap.set([media, heading, cta].filter(Boolean), { clearProps: 'transform,opacity,visibility,fontSize' });

      // Measure the assembled (natural) layout to derive the hero start scale.
      var gridRect = grid.getBoundingClientRect();
      var cellRect = center.getBoundingClientRect();
      var fillScale = gridRect.height / cellRect.height;

      // Per-tile reveal position, ordered by distance from the hero.
      var cellCx = cellRect.left + cellRect.width / 2;
      var cellCy = cellRect.top + cellRect.height / 2;
      var dists = others.map(function (t) {
        var r = t.getBoundingClientRect();
        return Math.hypot((r.left + r.width / 2) - cellCx, (r.top + r.height / 2) - cellCy);
      });
      var maxD = Math.max.apply(null, dists) || 1;

      // Heading start/end sizes come from CSS custom properties (responsive).
      var cs = getComputedStyle(heading || document.body);
      var headFrom = heading ? cs.getPropertyValue('--tr-heading-from').trim() : null;
      var headTo = heading ? cs.getPropertyValue('--tr-heading-to').trim() : null;

      // Desktop: pin the section and scrub the timeline against scroll.
      // Mobile: no pin/scrub — play through once when the section scrolls into
      // view, so the page keeps scrolling normally.
      var isDesktop = window.matchMedia('(min-width: 990px)').matches;
      var st = isDesktop
        ? {
            trigger: root,
            start: 'top top',
            end: function () {
              var vh = window.innerHeight;
              var pct = parseFloat(getComputedStyle(root).getPropertyValue('--tr-scroll-length')) || 200;
              return '+=' + (vh * pct / 100);
            },
            scrub: 0.5,
            pin: true,
            anticipatePin: 1,
            invalidateOnRefresh: true
          }
        : {
            // Fires once the section's top reaches the middle of the viewport,
            // rather than as soon as it edges into view — stops a fast scroll
            // past the section from burning the one-shot reveal off-screen.
            trigger: root,
            start: 'top center',
            once: true
          };

      tl = gsap.timeline({
        defaults: { ease: 'power2.out' },
        // A touch quicker on mobile since it self-plays rather than scrubbing.
        smoothChildTiming: true,
        scrollTrigger: st
      });
      if (!isDesktop) {
        tl.timeScale(1.3);
        tl.eventCallback('onComplete', function () { mobilePlayed = true; });
      }

      // Centre image: fill height -> settle into cell.
      tl.fromTo(media,
        { scale: fillScale },
        { scale: 1, duration: 0.65, ease: 'power2.inOut' }, 0);

      // The image scales about its centre, so its top edge starts this far above
      // the cell's top. The heading rides that edge so it stays pinned to the TOP
      // of the enlarged image, then settles to the cell top. Same ease/duration
      // as the scale, so the two track exactly.
      var headTopOffset = (fillScale - 1) * cellRect.height / 2;

      // Heading: crisp font-size tween + travel with the image's top edge.
      if (heading && headFrom && headTo) {
        tl.fromTo(heading,
          { fontSize: headFrom, y: -headTopOffset },
          { fontSize: headTo, y: 0, duration: 0.65, ease: 'power2.inOut' }, 0);
      }

      // Surrounding tiles: fade + scale in, nearest-first with seeded jitter.
      others.forEach(function (t, i) {
        var near = dists[i] / maxD;                    // 0 = nearest, 1 = farthest
        var jitter = (seeded(i) - 0.5) * 0.18;
        var pos = Math.min(0.85, Math.max(0.04, 0.10 + near * 0.6 + jitter));
        var startScale = 0.45 + seeded(i + 100) * 0.25;
        var yOff = (seeded(i + 200) - 0.5) * 48;
        tl.fromTo(t,
          { autoAlpha: 0, scale: startScale, y: yOff },
          { autoAlpha: 1, scale: 1, y: 0, duration: 0.4 }, pos);
      });

      // CTA fades in near the end, once the grid has mostly assembled.
      if (cta) {
        tl.fromTo(cta, { autoAlpha: 0, y: 12 }, { autoAlpha: 1, y: 0, duration: 0.25 }, 0.72);
      }
    }

    build();

    // Rebuild (re-measure hero scale) on resize; ScrollTrigger.refresh alone
    // can't re-record the baked from/to values.
    //
    // Width-only: mobile browsers fire resize every time the URL bar shows or
    // hides while scrolling. Rebuilding on those would re-arm the `once` trigger
    // and replay the reveal, so height-only changes are ignored.
    var raf;
    var lastWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastWidth) return;
      var wasDesktop = lastWidth >= 990;
      lastWidth = window.innerWidth;
      // Crossing the breakpoint swaps pin/scrub for play-once (or back), so the
      // mobile "already played" latch has to clear.
      if (wasDesktop !== (lastWidth >= 990)) mobilePlayed = false;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(build);
    });

    // Wait for late-loading images so measurements are correct.
    root.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', function () { ScrollTrigger.refresh(); }, { once: true });
    });
  }

  function init() {
    document.querySelectorAll('[data-team-reveal]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-team-reveal]');
    if (root) { root.__trInit = false; setup(root); }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["script-text-left-banner"] && !Shopify.designMode) return;
  try {
    /* Text left banner — staggered stats reveal.
 *
 * The stats panel's rows, rules and heading fade up as the panel enters view.
 * The pre-reveal state (opacity: 0) lives in CSS so nothing flashes in before
 * this deferred script runs — which means every exit path here MUST clear it.
 *
 * GSAP + ScrollTrigger are loaded globally in layout/theme.liquid.
 * Hooks: [data-tlb-stats] on the panel, [data-tlb-item] on each revealed child.
 */
(function () {
  var REDUCED = '(prefers-reduced-motion: reduce)';

  // The CSS-hidden state is a promise this script has to keep. Used for reduced
  // motion, a missing GSAP, and as the belt-and-braces fallback below.
  function showInstantly(panel, items) {
    panel.classList.add('is-revealed');
    items.forEach(function (el) {
      el.style.opacity = '1';
    });
  }

  function setup(panel) {
    if (panel.__tlbInit) return;
    panel.__tlbInit = true;

    var items = Array.prototype.slice.call(panel.querySelectorAll('[data-tlb-item]'));
    if (!items.length) return;

    var canAnimate =
      !window.matchMedia(REDUCED).matches &&
      typeof gsap !== 'undefined' &&
      typeof ScrollTrigger !== 'undefined';

    if (!canAnimate) {
      showInstantly(panel, items);
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    gsap.set(items, { opacity: 0, y: 24 });

    gsap.to(items, {
      opacity: 1,
      y: 0,
      duration: 0.7,
      ease: 'power2.out',
      stagger: 0.08,
      onComplete: function () {
        panel.classList.add('is-revealed');
      },
      scrollTrigger: {
        trigger: panel,
        // Fires immediately when the panel is already in view on load, which is
        // the usual case for this hero.
        start: 'top 88%',
        once: true,
      },
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-tlb-stats]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["script-text-media-tiles"] && !Shopify.designMode) return;
  try {
    /*
 * Text & media tiles — tile slider. Mobile/tablet only: auto-width 224px
 * slides that bleed past the site margin. From 992 the Swiper is destroyed
 * and the wrapper falls back to the CSS flex row.
 * Swiper is loaded globally in theme.liquid.
 * Hooks: [data-tmt-slider]
 */

(function () {
  const DESKTOP = window.matchMedia('(min-width: 992px)');
  const instances = new WeakMap();

  function sync(el) {
    if (!window.Swiper) return;

    if (DESKTOP.matches) {
      const swiper = instances.get(el);
      if (swiper) {
        swiper.destroy(true, true);
        instances.delete(el);
      }
      return;
    }

    if (instances.has(el)) return;

    instances.set(
      el,
      new window.Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        speed: 400,
        grabCursor: true,
        watchOverflow: true,
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
        },
      })
    );
  }

  function syncAll(scope) {
    (scope || document).querySelectorAll('[data-tmt-slider]').forEach(sync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncAll();
    });
  } else {
    syncAll();
  }

  DESKTOP.addEventListener('change', function () {
    syncAll();
  });

  document.addEventListener('shopify:section:load', function (e) {
    syncAll(e.target);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["script-video-carousel"] && !Shopify.designMode) return;
  try {
    /*
 * Video carousel — poster cards that open the YouTube player in a modal.
 *
 * Nothing is embedded inline. A live iframe consumes every pointer event, so a
 * played card could never be dragged again and the embed and the slider fought
 * over the gesture — a cross-origin boundary the page can't work around. Cards
 * are plain buttons, so dragging and tapping behave like any other slide, and
 * only one player is ever created, on demand.
 *
 * Hooks: [data-video-carousel], [data-vc-slider], [data-vc-play], [data-vc-poster],
 *        [data-vc-modal], [data-vc-modal-player], [data-vc-modal-close]
 */

(function () {
  const DRAG_SLOP = 6;
  const FOCUSABLE = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

  /* Largest first. maxresdefault and sddefault only exist if YouTube generated
     them; hqdefault always does (4:3 with bars that object-fit: cover trims). */
  const POSTER_SIZES = ['maxresdefault', 'sddefault', 'hqdefault'];
  const POSTER_PLACEHOLDER_W = 120;

  function initPosters(root) {
    root.querySelectorAll('[data-vc-poster]').forEach(function (img) {
      const id = img.dataset.vcPoster;
      if (!id) return;
      let step = 0;

      function next() {
        step += 1;
        if (step >= POSTER_SIZES.length) return;
        img.src = 'https://i.ytimg.com/vi/' + id + '/' + POSTER_SIZES[step] + '.jpg';
      }

      /* A missing size answers 404 with a decodable 120x90 grey placeholder, so
         the browser fires load rather than error and an error handler alone
         never runs. The decoded width is the only reliable tell. */
      function check() {
        if (img.naturalWidth && img.naturalWidth <= POSTER_PLACEHOLDER_W) next();
      }

      img.addEventListener('error', next);
      img.addEventListener('load', check);
      if (img.complete) check();
    });
  }

  function initModal(root) {
    const modal = root.querySelector('[data-vc-modal]');
    const mount = root.querySelector('[data-vc-modal-player]');
    const closeBtn = root.querySelector('[data-vc-modal-close]');
    const loader = root.querySelector('[data-vc-modal-loader]');
    if (!modal || !mount) return null;

    let lastFocused = null;

    function close() {
      if (modal.hidden) return;
      modal.hidden = true;
      // Removing the iframe is what stops playback — there's no API to call.
      // Targeted rather than wiping the mount, so the loader survives.
      const frame = mount.querySelector('iframe');
      if (frame) frame.remove();
      if (loader) loader.hidden = true;
      document.documentElement.style.overflow = '';
      if (lastFocused) lastFocused.focus();
      lastFocused = null;
    }

    function open(videoId, format) {
      lastFocused = document.activeElement;
      mount.dataset.vcFormat = format || 'standard';

      const stale = mount.querySelector('iframe');
      if (stale) stale.remove();
      if (loader) loader.hidden = false;

      /* Reveal BEFORE mounting the player. A browser won't start playback in a
         display:none subtree, so building the iframe first and un-hiding after
         meant autoplay was dropped — strictly enforced on mobile. */
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';

      const frame = document.createElement('iframe');
      frame.className = 'video-carousel_modal-frame';
      frame.title = 'YouTube video player';
      frame.allow =
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      frame.allowFullscreen = true;
      frame.src =
        'https://www.youtube.com/embed/' +
        encodeURIComponent(videoId) +
        '?autoplay=1&playsinline=1&rel=0&modestbranding=1';

      if (loader) {
        // Fires when YouTube's player document has loaded, which is the point
        // the spinner has stopped being useful.
        frame.addEventListener('load', function () { loader.hidden = true; }, { once: true });
      }

      mount.appendChild(frame);

      if (closeBtn) closeBtn.focus();
    }

    if (closeBtn) closeBtn.addEventListener('click', close);

    modal.addEventListener('click', function (e) {
      if (e.target === modal) close();
    });

    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') {
        close();
        return;
      }
      if (e.key !== 'Tab') return;
      // Keep focus inside the dialog.
      const items = Array.from(modal.querySelectorAll(FOCUSABLE)).filter(function (el) {
        return el.offsetParent !== null;
      });
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    return { open: open, close: close };
  }

  /* Swiper drags fire a click on release, so a card would open on every swipe.
     Measure pointer travel and only treat a still pointer as a tap. */
  function initCards(root, modal) {
    if (!modal) return;

    root.querySelectorAll('[data-vc-play]').forEach(function (card) {
      let start = null;

      card.addEventListener('pointerdown', function (e) {
        start = { x: e.clientX, y: e.clientY };
      });

      card.addEventListener('click', function (e) {
        // No pointer data means this wasn't a drag — a keyboard activation, or
        // a browser that didn't give us pointerdown. Treat it as a tap rather
        // than measuring against 0,0 and swallowing a legitimate one.
        const travelled =
          start !== null &&
          (Math.abs(e.clientX - start.x) > DRAG_SLOP || Math.abs(e.clientY - start.y) > DRAG_SLOP);
        start = null;

        if (travelled) {
          e.preventDefault();
          return;
        }
        modal.open(card.dataset.vcId, card.dataset.vcFormat);
      });
    });
  }

  function initSection(root) {
    if (root.dataset.vcInit === 'true') return;
    root.dataset.vcInit = 'true';

    initPosters(root);
    initCards(root, initModal(root));

    const el = root.querySelector('[data-vc-slider]');
    if (!el || !window.Swiper) return;

    function endOffset() {
      const overflow = el.getBoundingClientRect().right - document.documentElement.clientWidth;
      return Math.max(0, Math.round(overflow));
    }

    new window.Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 24,
      speed: 400,
      watchSlidesProgress: true,
      threshold: DRAG_SLOP,
      slidesOffsetAfter: endOffset(),
      on: {
        resize: function (swiper) {
          swiper.params.slidesOffsetAfter = endOffset();
          swiper.update();
        },
      },
      mousewheel: {
        forceToAxis: true,
        releaseOnEdges: true,
      }
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-video-carousel]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
